import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import SchemaOrg from '@/components/feature/SchemaOrg';
import HeroSection from './components/HeroSection';
import CategorySection from './components/CategorySection';
import FeaturedGames from './components/FeaturedGames';
import PromotionsSection from './components/PromotionsSection';
import AdvantagesSection from './components/AdvantagesSection';
import NewsSection from './components/NewsSection';
import FAQSection from './components/FAQSection';
import CtaSection from './components/CtaSection';

const homeSchema = {
  '@context': 'https://schema.org',
  '@type': 'WebSite',
  name: '新葡京娱乐城',
  url: 'https://sportsinn.github.io',
  description: '新葡京娱乐城是顶级在线娱乐平台，提供真人百家乐、老虎机、体育竞猜等多元游戏。',
  potentialAction: {
    '@type': 'SearchAction',
    target: 'https://sportsinn.github.io/search?q={search_term_string}',
    'query-input': 'required name=search_term_string',
  },
};

export default function Home() {
  return (
    <>
      <SchemaOrg schema={homeSchema} />
      <Navbar />
      <main>
        <HeroSection />
        <CategorySection />
        <FeaturedGames />
        <PromotionsSection />
        <AdvantagesSection />
        <NewsSection />
        <FAQSection />
        <CtaSection />
      </main>
      <Footer />
    </>
  );
}